import { forwardRef, useState } from "react";
import {
  Box,
  Typography as MuiTypography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import styled from "@emotion/styled";

import ArrowDownCircleIcon from "@/components/Icons/ArrowDownCircleIcon";

const Typography = styled(MuiTypography)`
  color: #21245c;
`;

const StyledAccordion = styled(Accordion)`
  padding: 12px 24px;
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 0px;
  border: none;

  &.Mui-expanded {
    min-height: 48px;
  }

  .MuiAccordionSummary-content {
    margin: 0;
  }

  .MuiAccordionSummary-expandIcon {
    color: #6064f8;
  }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 0;
  display: flex;
  flex-direction: column;
`;

interface CoverageAccordionProps {
  coverage: {
    id: string;
    title: string;
    description: string;
    example: string;
  };
  expanded: boolean;
}

const CoverageAccordion = forwardRef((props: CoverageAccordionProps, ref) => {
  const { id, title, description, example } = props.coverage;
  const [open, setOpen] = useState(props.expanded);

  const handleChange = () => {
    setOpen(!open);
  };

  return (
    <Box mb={2} id={id}>
      <StyledAccordion ref={ref} expanded={open} onChange={handleChange}>
        <StyledAccordionSummary expandIcon={<ArrowDownCircleIcon />}>
          <Typography variant="h4" style={{ fontSize: 20 }}>
            {title}
          </Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <Box mb={2}>
            <Typography>{description}</Typography>
          </Box>
          <Box p={2} mb={1.5} borderRadius={8} bgcolor="#f5f5ff">
            <Box mb={1}>
              <Typography
                variant="h5"
                style={{
                  fontWeight: 600,
                  opacity: 0.5,
                }}
              >
                Example
              </Typography>
            </Box>
            <Typography>{example}</Typography>
          </Box>
        </StyledAccordionDetails>
      </StyledAccordion>
    </Box>
  );
});

export default CoverageAccordion;
